/* eslint-disable */
import { useContext, useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useSelector } from "react-redux";

import { login } from "../../store/authSlice";
import { useAppDispatch } from "../../store/store";
import { LocalizationContext } from "../../App";
import { ClosedEye, OpenedEye } from "../../common/icons";
import { AuthLayout } from "../../layout/AuthLayout";

const schema = yup.object().shape({
  username: yup.string().required("Username is required"),
  password: yup.string().required("Password is required"),
});

const Login = () => {
  const actionDispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  const l10n = useContext(LocalizationContext);
  const isUserLogged = useSelector((state: any) => state.auth.isUserLogged);
  const md5Key = useSelector((state: any) => state.auth.md5Key);
  const qrCodeImage = useSelector((state: any) => state.auth.qrCodeImage);
  const manualSetupKey = useSelector((state: any) => state.auth.manualSetupKey);
  const error = useSelector((state: any) => state.auth.error);

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = (): void => {
    setIsPasswordVisible((prevState) => !prevState);
  }

  const onSubmit = (data: any) => {
    actionDispatch(login({ username: data.username, password: data.password }));
  };

  useEffect(() => {
    if (isUserLogged) {
      navigate("/");
    }
    if (md5Key != null) {
      navigate("/tfaVerify", {
        state: {
          md5: md5Key,
          manualSetupKey: manualSetupKey,
          qrCodeImage: qrCodeImage,
        },
      });
    }
  }, [isUserLogged, md5Key, manualSetupKey, qrCodeImage, navigate]);

  return (
    <AuthLayout>
      <form
        className="h-full flex flex-1 flex-col justify-between items-stretch landscape:pb-8"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div>
          <h2>{l10n.title.login}</h2>
          <div className="form-group">
            <label htmlFor="email">{l10n.label.yourEmail}</label>
            <input
              autoComplete="email"
              className="form-control"
              id="email"
              placeholder="Your email address" // TODO: Add proper placeholder
              type="email"
              {...register("username")}
            />
            {errors.username && <p className="invalid-feedback">{errors.username.message}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="password">{l10n.label.yourPassword}</label>
            <div className="input-group">
              <input
                autoComplete="current-password"
                className="form-control"
                id="password"
                placeholder="Your password" // TODO: Add proper placeholder
                type={isPasswordVisible ? "text" : "password"}
                {...register("password")}
              />
              <div
                className="absolute inset-y-0 end-0 flex items-center z-20 pe-input-x"
                onClick={togglePasswordVisibility}
              >
                {isPasswordVisible ? (
                  <ClosedEye className="w-5 h-5 stroke-input-group-icon" />
                ) : (
                  <OpenedEye className="w-5 h-5 stroke-input-group-icon" />
                )}
              </div>
            </div>
            {errors.password && <p className="invalid-feedback">{errors.password.message}</p>}

            {error && error === "invalidCredentials" && (
              <>
                <br />
                <p className="invalid-feedback">{l10n.auth.wrongCredentials}</p>
              </>
            )}
          </div>
        </div>
        <div className="btn-group">
          <button className="btn btn-primary" type="submit">{l10n.btn.logIn}</button>
          <button className="btn btn-secondary" type="button">
            <Link to="/forgot-password">{l10n.btn.forgotPassword}</Link>
          </button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default Login;
